import { render, staticRenderFns } from "./wxconfiguration.vue?vue&type=template&id=d160fcb0&scoped=true"
import script from "./wxconfiguration.vue?vue&type=script&lang=js"
export * from "./wxconfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d160fcb0",
  null
  
)

export default component.exports